import { Component, input } from '@angular/core';
import { IzaBubbleComponent } from '@rmfarma/iza';

@Component({
  selector: 'app-iza-bubble-host',
  standalone: true,
  imports: [IzaBubbleComponent],
  templateUrl: './iza-bubble-host.component.html',
})
export class IzaBubbleHostComponent {
  show = input(false);
}
